import ApplicationController from './application_controller';

export default class extends ApplicationController {
  toggle() {
    const navMenu = document.getElementById('nav-menu');
    const isHidden = navMenu.classList.toggle('hidden');

    document.body.classList.toggle('overflow-hidden');

    // Keep the toggle button's state exposed to assistive tech (WCAG 4.1.2).
    this.element.setAttribute('aria-expanded', String(!isHidden));
    this.element.setAttribute('aria-label', isHidden ? 'Open menu' : 'Close menu');
  }
}
